import React, {useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/main-02.module.css';

import {ReactComponent as BodyCherishImg} from '../../assets/main02/body-cherish.svg';
import {ReactComponent as BusinessPtImg} from '../../assets/main02/business-pt.svg';
import {ReactComponent as HyosungImg} from '../../assets/main02/hyosung.svg';
import {ReactComponent as HyundaiImg} from '../../assets/main02/hyundai.svg';
import {ReactComponent as KolonImg} from '../../assets/main02/kolon.svg';
import {ReactComponent as MProImg} from '../../assets/main02/m-pro.svg';
import {ReactComponent as SeoulCityImg} from '../../assets/main02/seoul-city.svg';
import {ReactComponent as SeoulWomenImg} from '../../assets/main02/seoul-women.svg';
import {ReactComponent as ValeoImg} from '../../assets/main02/valeo.svg';
import {ReactComponent as WoojinImg} from '../../assets/main02/woojin.svg';

const easeInMotion = {
    ease: 'easeIn',
    duration: 0.8
};

const slideMotion= {
    hidden: { x: '0%' },
    visible: {
        x: '-50%',
        transition: {
            duration: 240,      // 전체 슬라이드 시간
            repeat: Infinity,  // 무한 반복
            repeatType: 'loop',
            ease: 'linear'     // 일정한 속도
      }
    }
};

export default function Main02() {
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

    const ref = useRef(null);
    
    const isInView = useInView(ref, {
        once: true,
        amount: mobileMedium ? 0.1 : 0.2,         // 20%만 보여도 트리거
        margin: mobileMedium ? '-30px 0px' :'-100px 0px' // 뷰포트 진입 전 100px에서 트리거
    });

    const withCompanyMap = [
        { id: 1, Component: HyundaiImg },
        { id: 2, Component: ValeoImg },
        { id: 3, Component: BusinessPtImg },
        { id: 4, Component: WoojinImg },
        { id: 5, Component: SeoulCityImg },
        { id: 6, Component: KolonImg },
        { id: 7, Component: BodyCherishImg },
        { id: 7, Component: HyosungImg },
        { id: 8, Component: SeoulWomenImg },
        { id: 9, Component: MProImg }
    ];

    return (
        <div className={styles.wrapper}>
            <div className={styles.container} ref={ref}>
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={isInView ? { opacity: 1 } : { opacity: 0 }}
                    transition={easeInMotion}
                >
                    함께하는 기업들을 소개해요
                </motion.p>
                <motion.div
                    initial='hidden'
                    animate={isInView ? 'visible' : 'hidden'}
                    variants={slideMotion}
                    style={{ display: 'flex' }}
                >
                    {withCompanyMap.map(({ id, Component }) => (
                        <Component key={id} data-type={id} />
                    ))}
                    {withCompanyMap.map(({ id, Component }) => (
                        <Component key={`${id}-duplicate-1`} data-type={id} />
                    ))}
                    {withCompanyMap.map(({ id, Component }) => (
                        <Component key={`${id}-duplicate-2`} data-type={id} />
                    ))}
                    {withCompanyMap.map(({ id, Component }) => (
                        <Component key={`${id}-duplicate-3`} data-type={id} />
                    ))}
                    {withCompanyMap.map(({ id, Component }) => (
                        <Component key={`${id}-duplicate-4`} data-type={id} />
                    ))}
                    {withCompanyMap.map(({ id, Component }) => (
                        <Component key={`${id}-duplicate-5`} data-type={id} />
                    ))}
                </motion.div>
            </div>
        </div>
    );
}
